import { DateFieldWithPrefixProps, DateFieldWithPrefix, useFieldHelper } from 'framework/ui/field';
import { Box, Typography } from '@mui/material';

const ProjectDatePeriodField = ({
  fromProps,
  toProps,
  isShowEmptyForm = true,
  isShowEmptyTo = true,
}: {
  fromProps: DateFieldWithPrefixProps;
  toProps: DateFieldWithPrefixProps;
  isShowEmptyForm?: boolean;
  isShowEmptyTo?: boolean;
}) => {
  const { getValue: getFrom } = useFieldHelper({ source: fromProps.source });
  const { getValue: getTo } = useFieldHelper({ source: toProps.source });

  const from = getFrom();
  const to = getTo();

  const shouldShowFrom = from ? true : isShowEmptyForm;
  const shouldShowTo = to ? true : isShowEmptyTo;

  const shouldShowSeparator = shouldShowFrom && shouldShowTo;

  return (
    <Box display="flex" gap="7px" alignItems="center">
      {shouldShowFrom && <DateFieldWithPrefix {...fromProps} />}

      {shouldShowSeparator && <Typography>-</Typography>}

      {shouldShowTo && <DateFieldWithPrefix {...toProps} />}
    </Box>
  );
};

export default ProjectDatePeriodField;
